import React from 'react';
import CountrySelect from './CountrySelect';

// Pre-existing behavior: FocusableInput's cloneElement overrides any onBlur
// on the underlying select, so the form's onBlur prop never fires here.
// Kept for behavior parity with the previous inline implementation.
export default function CountryField({ field, onChange }) {
  return (
    <CountrySelect
      id={field._id}
      label={field.label}
      placeholder={field.placeholder || 'Select an option'}
      required={field.required}
      value={field.value}
      onChange={onChange}
      limitAllowedCountries={field.limitAllowedCountries}
      focusableInputId={field._id}
    />
  );
}
